import React, { useState, useEffect } from "react";
import { PrivacyPolicy } from "./PrivacyPolicy";
import { TermsandCondition } from "./TermsandCondition";

export const PrivacyTerms = () => {
  const [selTab, setSelTab] = useState(1);

  const tab = (name, id) => {
    return (
      <li className="nav-item" role="presentation">
        <a
          className={`nav-link ${selTab == id ? "active" : ""}`}
          href={"#tab" + id}
          role="tab"
          aria-selected={selTab == id ? "true" : "false"}
          onClick={() => setSelTab(id)}
        >
          {name}
        </a>
      </li>
    );
  };

  useEffect(() => {
    const hash = window.location.hash;
    const tabId = parseInt(hash.replace("#tab", ""), 10);
    if (tabId >= 1 && tabId <= 2) {
      setSelTab(tabId);
    }
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Policies</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Configuration</a>
              </li>
              <li className="breadcrumb-item active">Policies</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <ul
            className="nav nav-tabs nav-tabs-bottom nav-justified"
            role="tablist"
          >
            {tab("Privacy Policy", 1)}
            {tab("Terms and Conditions", 2)}
          </ul>
          <div className="tab-content">
            <div
              className={`tab-pane ${selTab == 1 ? "active show" : ""}`}
              id="tab1"
              role="tabpanel"
            >
              {selTab == 1 && <PrivacyPolicy />}
            </div>
            <div
              className={`tab-pane ${selTab == 2 ? "active show" : ""}`}
              id="tab2"
              role="tabpanel"
            >
              {selTab == 2 && <TermsandCondition />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
